import _ from 'lodash'
import React, { useEffect, useMemo } from 'react'

import DoctorIcon from '@/components/ui/icons/Doctor'
import PdsIcon from '@/components/ui/icons/Pds'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { getChatRoom, selectChatRoomById, sendChatMessage } from '@/redux/reducers/chat-room.reducer'

import Messenger, { MessengerProps } from '../components/Messenger'

export function MessengerContainer(props: Omit<MessengerProps, 'dataSource' | 'onSendMessage'>) {
  const { chatRoomId } = props
  const dispatch = useAppDispatch()
  const authUser = useAppSelector(selectAuthUser)
  const chatRoom = useAppSelector((state) => (chatRoomId ? selectChatRoomById(state, chatRoomId) : undefined))

  const dataSource: MessengerProps['dataSource'] = useMemo(() => {
    if (!chatRoom || !authUser) return []

    return _.map(chatRoom.messages, (chatMessage, index) => {
      const author = _.find(chatRoom.users, (user) => user._id === chatMessage.author)
      return {
        data: {
          text: chatMessage.content,
        },
        isMine: authUser._id === chatMessage.author,
        reads: _.map(
          _.filter(chatRoom.users, (user) => chatMessage.readBy.includes(user._id)),
          (member) => ({
            id: member._id,
            name: member.userInfo.name,
            surname: member.userInfo.surname,
            renderIcon: ({ sx }) =>
              member.status === 'PDS' ? (
                <PdsIcon isFemale={author?.userInfo.gender === 'F'} sx={sx} />
              ) : (
                <DoctorIcon isFemale={author?.userInfo.gender === 'F'} sx={sx} />
              ),
          })
        ),
        date: chatMessage.date,
        author: !!author
          ? {
              id: author._id,
              name: author.userInfo.name,
              surname: author.userInfo.surname,
              renderIcon: ({ sx }) =>
                author.status === 'PDS' ? (
                  <PdsIcon isFemale={author?.userInfo.gender === 'F'} sx={sx} />
                ) : (
                  <DoctorIcon isFemale={author?.userInfo.gender === 'F'} sx={sx} />
                ),
            }
          : undefined,
        type: 'text',
      }
    })
  }, [authUser, chatRoom])

  useEffect(() => {
    if (chatRoomId) {
      dispatch(getChatRoom(chatRoomId))
    }
  }, [dispatch, chatRoomId])

  const handleSendMessage = (message: string) => {
    if (chatRoomId) dispatch(sendChatMessage(chatRoomId, message))
  }

  return <Messenger dataSource={dataSource} onSendMessage={handleSendMessage} {...props} />
}

export default MessengerContainer
